module.exports = __webpack_public_path__ + "static/О гос гражданской службе РС(Я) (ред от 19_06_2019).doc";